module.exports = __webpack_public_path__ + "static/commercial-auto-insurance-34f9158a173e6f4e875bcc8d0f6e902f.svg";